(() => {
  if (window.MasterConversionControlLoaded) return;
  window.MasterConversionControlLoaded = true;

  /*
    MASTER — Conversión es la autoridad del flujo después de añadir.

    Antes esta sección pisaba el valor del drawer «por si acaso» mientras el
    ajuste global seguía visible en Configuración del tema: dos controles para
    un mismo comportamiento y ninguna forma de saber cuál mandaba. Ahora el
    global está retirado del editor y vive en `afterAddLegacy`, que sólo se lee
    si esta sección no existe.

    Por eso, si la sección desaparece (el merchant la quita en el editor y
    Shopify recarga sólo ese trozo), hay que BORRAR el dataset en vez de dejar
    el último valor pegado: si no, la autoridad retirada seguiría gobernando
    hasta la siguiente recarga completa.
  */
  const apply = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const cfg = document.querySelector('[data-master-conversion-config]');
    if (!cfg) {
      if (drawer) delete drawer.dataset.afterAdd;
      return;
    }
    if (drawer) {
      if (cfg.dataset.afterAdd) drawer.dataset.afterAdd = cfg.dataset.afterAdd;
      else delete drawer.dataset.afterAdd;
    }
    document.dispatchEvent(new CustomEvent('master:conversion-config', {detail:{config:{...cfg.dataset}}}));
  };

  apply();
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:section:unload', apply);
  document.addEventListener('shopify:section:reorder', apply);
})();
